import React from 'react';
import { renderHTML } from '@agility/nextjs';
import { styled } from '@mui/material/styles';
import { useSession } from 'next-auth/react';
import Box from '@mui/material/Box';
import { isCustomer } from 'services/subscriptionUtils';
import useMyLearning from '../../hooks/useMyLearning';

const Container = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    padding: '5px',
    margin: '5px 0 10px 0',
  },
  [theme.breakpoints.down('md')]: {
    padding: '10px',
    margin: '5px 2px 5px 2px',
  },
}));
const IntroText = styled('div')(({ theme }) => ({
  color: theme.palette.common.black,
  margin: 5,
  '& li': {
    '&::before': {
      backgroundColor: '#000 !important',
    },
  },
}));

const Paragraphs = ({ module }) => {
  const { fields } = module;
  const { data: session } = useSession();
  const isMyLearning = useMyLearning();

  let paragraphText;

  if (isCustomer(session?.user)) {
    paragraphText = isMyLearning
      ? fields?.paragraphTextForMyLearning
      : fields.paragraphTextwithSession || fields.paragraphText;
  } else {
    paragraphText = fields.paragraphTextwithSession || fields.paragraphText;
  }

  return (
    <Box
      sx={{
        width: '100%',
        ml: 'auto',
        mr: 'auto',
        maxWidth: { sm: '540px', md: '768px', lg: '1180px', xl: '1180px' },
      }}
    >
      <Container>
        <IntroText
          className="prose max-w-full mx-auto"
          dangerouslySetInnerHTML={renderHTML(paragraphText)}
        />
      </Container>
    </Box>
  );
};

export default Paragraphs;

